import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  DialogActions,
  Button,
} from '@mui/material';
import React from 'react';
import {useSnackbar} from 'notistack';
import {useAddCertificateMutation, useLazyGetUploadUrlQuery, useGetOrganizationsQuery} from 'api';
import CertificateForm from './CertificateForm';

function CreateCertificateModal({open, onClose}) {
  const {data, isLoading, isError} = useGetOrganizationsQuery();
  const formRef = React.useRef();
  const [addCertificate] = useAddCertificateMutation();
  const [getUploadUrl] = useLazyGetUploadUrlQuery();
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();
  return (
    <Dialog fullWidth scroll="body" maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle mb={2} variant="h6">
        Create Certificate
      </DialogTitle>
      <DialogContent>
        <CertificateForm
          disabled={isLoading || isError}
          ref={formRef}
          organizationList={data}
          onSubmit={async (values, actions) => {
            try {
              setIsSubmitting(true);
              const formData = new FormData();
              formData.append(`file`, values.icon.file);
              const {url} = await getUploadUrl().unwrap();
              const response = await fetch(url, {
                method: 'POST',
                body: formData,
              });
              if (!response.ok) {
                throw new Error('Failed to upload icon.');
              }
              const uploadResult = await response.json();
              const newObj = {
                ...values,
                icon: uploadResult.result.id,
              };
              await addCertificate(newObj).unwrap();
              actions.resetForm();
              enqueueSnackbar('Certificate created successfully', {
                variant: 'success',
              });
              onClose();
            } catch (e) {
              const message =
                e.status === 400 ? e.certificateResponse?.details?.[0]?.message : undefined;
              enqueueSnackbar(message || 'Failed to create Certificate', {
                variant: 'error',
              });
            } finally {
              setIsSubmitting(false);
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={isSubmitting} color="inherit" variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          endIcon={isSubmitting ? <CircularProgress ml={2} size={16} /> : null}
          disabled={isSubmitting}
          color="primary"
          variant="contained"
          onClick={() => formRef.current?.submit?.()}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreateCertificateModal;
